import { CALYPSO } from 'HubStyleTokens/colors';
import UICardHeader from 'UIComponents/card/UICardHeader';
import UICardSection from 'UIComponents/card/UICardSection';
import UICardWrapper from 'UIComponents/card/UICardWrapper';
import UIIcon from 'UIComponents/icon/UIIcon';
import { AccordionTransition } from 'foundations-components/transitional/components/AccordionTransition';
import { TFlex } from 'foundations-components/transitional/components/TFlex';
import styled from 'foundations-theming/utils';
import { useState } from 'react';
import { useAppSelector } from '../../../reducers';
import { planBuilderProductConfigurationsSelector } from '../../../selectors/PlanBuilderSelectors';
import { skuIdIsAddonOrServiceSelector } from '../../../selectors/ProductsSelectors';
import { StyledTitleContainer } from '../SharedComponents';
import ExpandableChecklistItem from './ExpandableChecklistItem';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const TextContainer = styled.div.withConfig({
  displayName: "ExpandableChecklist__TextContainer",
  componentId: "sc-1hg9lx-0"
})(["&:hover{cursor:pointer;}"]);
const Container = styled(UICardWrapper).withConfig({
  displayName: "ExpandableChecklist__Container",
  componentId: "sc-1hg9lx-1"
})(["max-width:700px;"]);
const StyledCardHeader = styled(UICardHeader).withConfig({
  displayName: "ExpandableChecklist__StyledCardHeader",
  componentId: "sc-1hg9lx-2"
})(["& > div > span{width:inherit;}"]);
const CardSection = styled(UICardSection).withConfig({
  displayName: "ExpandableChecklist__CardSection",
  componentId: "sc-1hg9lx-3"
})(["padding-bottom:12px;&:last-child{padding-bottom:40px;}"]);
const ExpandableChecklist = ({
  title,
  subtext,
  skuIds = [],
  onSelectedChange,
  use,
  defaultOpen,
  trackAccordionInteraction
}) => {
  const productConfigurations = useAppSelector(planBuilderProductConfigurationsSelector);
  const hasSelectedMerch = useAppSelector(state => productConfigurations.filter(({
    skuId
  }) => skuIdIsAddonOrServiceSelector(state, {
    skuId
  })).length > 0);
  const [isOpen, setIsOpen] = useState(defaultOpen || hasSelectedMerch);
  const iconName = isOpen ? 'minus' : 'add';
  const toggleAccordion = () => {
    const newAccordionState = !isOpen;
    setIsOpen(newAccordionState);
    trackAccordionInteraction(use, newAccordionState);
  };
  const Wrapper = Container;
  const SectionContainer = CardSection;
  const ChecklistTitle = /*#__PURE__*/_jsxs(TextContainer, {
    onClick: toggleAccordion,
    "data-selenium-id": `plan-builder-${use}-checklist-toggle`,
    children: [/*#__PURE__*/_jsxs(TFlex, {
      direction: "row",
      justify: "between",
      children: [/*#__PURE__*/_jsx(StyledTitleContainer, {
        children: title
      }), /*#__PURE__*/_jsx(UIIcon, {
        color: CALYPSO,
        name: iconName,
        size: "medium"
      })]
    }), subtext]
  });
  return /*#__PURE__*/_jsx(_Fragment, {
    children: /*#__PURE__*/_jsxs(Wrapper, {
      children: [/*#__PURE__*/_jsx(StyledCardHeader, {
        titleSize: "xs",
        title: ChecklistTitle
      }), /*#__PURE__*/_jsx(AccordionTransition, {
        open: isOpen,
        "data-selenium-id": `plan-builder-${use}-checklist`,
        children: skuIds.map(skuId => {
          const selectedProductConfiguration = productConfigurations.find(({
            skuId: searchSkuId
          }) => searchSkuId === skuId);
          return /*#__PURE__*/_jsx(SectionContainer, {
            children: /*#__PURE__*/_jsx(ExpandableChecklistItem, {
              skuId: skuId,
              selectedQuantity: selectedProductConfiguration && selectedProductConfiguration.quantity || 0,
              onSelectedChange: onSelectedChange,
              use: use
            })
          }, skuId);
        })
      })]
    })
  });
};
export default ExpandableChecklist;